import React from "react";
import { useSeo } from "@/hooks/useSeo";
import { SEO } from "@/data/seo";
import { PRESS } from "@/data/press";
import { Overline, PrimaryButton, SecondaryButton, Crumbs } from "@/components/Primitives";
import CTABlock from "@/components/CTABlock";
import { Link } from "react-router-dom";

const Press = () => {
  useSeo(SEO.press);
  return (
    <main data-testid="press-page" className="bg-black">
      <section className="bg-black text-white border-b border-white/10">
        <div className="max-w-[1440px] mx-auto px-5 lg:px-10 py-12 lg:py-20">
          <Crumbs items={[{ to: "/", label: "Home" }, { label: "Press" }]} />
          <h1 className="mt-6 text-5xl sm:text-6xl lg:text-[80px] font-black tracking-tighter leading-[0.92]">
            Press. <span className="k-yellow">Honest list.</span>
          </h1>
          <p className="mt-5 max-w-2xl text-white/70 text-lg">
            We do not invent press mentions. When real features come in, they will live here.
          </p>
        </div>
      </section>
      <section className="bg-black">
        <div className="max-w-[1440px] mx-auto px-5 lg:px-10 py-16">
          {PRESS.length === 0 ? (
            <div data-testid="press-empty" className="border border-white/15 p-10">
              <Overline className="mb-3">No public features yet</Overline>
              <h2 className="text-3xl lg:text-5xl font-black tracking-tighter leading-[0.95] max-w-3xl">
                If you are a writer or producer working on a story, we would love to talk.
              </h2>
              <div className="mt-7 flex flex-wrap gap-3">
                <PrimaryButton to="/contact?source=press">Press inquiry</PrimaryButton>
                <SecondaryButton to="/about">Studio brief</SecondaryButton>
              </div>
            </div>
          ) : (
            <ul className="divide-y divide-white/10 border-y border-white/15">
              {PRESS.map((p) => (
                <li key={p.slug} className="py-5 flex items-center justify-between">
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.22em] text-white/60 font-semibold">{p.outlet}</div>
                    <div className="text-lg font-bold tracking-tight">{p.headline}</div>
                  </div>
                  {p.url ? <a href={p.url} target="_blank" rel="noreferrer" className="text-sm font-semibold underline underline-offset-4 hover:text-[#FFC600]">Open ↗</a> : null}
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>
      <CTABlock variant="default" />
    </main>
  );
};

export default Press;
